import { useEffect, useRef, useState } from 'react'
import { InputListItem } from '../footerTaps'

import './terminal.scss'

type TerminalTapProps = {
  inputList: Array<InputListItem>
  setInputList: (value: Array<InputListItem>) => void
}

function TerminalTap(props: Readonly<TerminalTapProps>) {
  const [input, setInput] = useState('')
  const terminalRef = useRef<HTMLDivElement>(null);
  const textareaRef = useRef<HTMLInputElement>(null);

  const commandList = ['clear', 'help']

  useEffect(() => {
    focusInput()
  }, [])

  const generateTextInTerminal = (div: JSX.Element) => {
    const newInputList = [...props.inputList]
    newInputList.push({ text: input })
    newInputList.push({ text: div, disabledPs: true })
    props.setInputList(newInputList)
    setInput('')
  }

  const _handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter') {
      // clear command
      if(input === 'clear') {
        props.setInputList([])
        setInput('')
        return
      } else if (input === 'help') {
        const div = (
          <div className='inputText-text inputText-text-valid'>
            {`>`} help
            <br/>
            {`>`} clear <span style={{marginLeft:34}}>Delete all previous commands</span>
          </div>
        )
        generateTextInTerminal(div)
        return
      } else if (input !== '') {
        const div = (
          <div className='inputText-text inputText-text-invalid'>
            The name "{input.split(' ')[0]}" was not recognized as the name of a cmdlet, a function, a script file or an executable program. cmd: help
            <br/>
            In line:1 Character:1
          </div>
        )
        generateTextInTerminal(div)
        return
      }

      scrollTerminal()

      const newInputList = [...props.inputList]
      newInputList.push({ text: input })
      props.setInputList(newInputList)
      setInput('')  
    }

    if (e.key === 'Tab') {
      e.preventDefault()
      if(input.trim().length > 0) {
        for (const cmd of commandList) {
          if(cmd.startsWith(input) && cmd !== input) {
            setInput(cmd)
            break
          }
        }
      }
    }
  }

  const scrollTerminal = () => {
    if(terminalRef?.current) {
      const offsetBottom = terminalRef.current.offsetTop + terminalRef.current.offsetHeight
      terminalRef.current.scrollTo({ top: offsetBottom })
    }
  }

  const focusInput = () => {
    textareaRef.current?.focus()
  }

  return (
    <div className='tap-terminal' ref={terminalRef} onClick={() => focusInput()} onKeyDown={_handleKeyDown}>

      {props.inputList.map(item => {
        if(item.disabledPs) {
          return (
            <div key={String(item)} className='terminal-input'>
              <div className='inputText noPs'>{item.text}</div>
            </div>
          )
        }
        return (
          <div key={String(item)} className='terminal-input'>
            <div>{'PS C:\\workspace\\dwain>'}</div>
            <div className='inputText'>{item.text}</div>
          </div>
        )
      })}

      <div className='terminal-input'>
        {'PS C:\\workspace\\dwain>'}
        <input
          className='inputText'
          value={input}
          onChange={(e) => setInput(e.target.value)}
          type='textarea'
          onKeyDown={_handleKeyDown}
          ref={textareaRef}
        />
      </div>

    </div>
  )
}

export default TerminalTap
